import { NullablePartial } from "../types/utils";
import { Address } from "../types/address";

export const getAddressFromCustomerDetailValue = (
  customerAddressValue?: string | null
): Partial<Address> => {
  if (!customerAddressValue) {
    return {} as Address;
  }
  return customerAddressValue ? JSON.parse(customerAddressValue) : {};
};

export const getAddressStringFromCustomerDetailValue = (
  customerAddressValue?: string | null
): string =>
  customerAddressValue
    ? renderAddressString(getAddressFromCustomerDetailValue(customerAddressValue))
    : "";

/**
 * Renders an address into a standard string flexibly.
 */
export const renderAddressString = ({
  street,
  street2,
  city,
  state,
  zip,
}: NullablePartial<Address>): string =>
  `${[street, street2, city, state]
    .filter((part): part is string => !!part)
    .map((part) => part.trim())
    .join(", ")}${zip ? ` ${zip}` : ""}`;

/**
 * For letter codes like state initials or region codes. Only keeps n letters and capitalizes them.
 */
export const cleanCapitalLetters =
  (maxLength: number) =>
  (value = ""): string =>
    (value || "")
      .replace(/[^a-zA-Z]/g, "")
      .slice(0, maxLength)
      .toUpperCase();

/**
 * For state codes. Only keeps 2 letters and capitalizes them.
 */
export const cleanStateCode = (value = ""): string => cleanCapitalLetters(2)(value);
